import { render } from "./ResizableImageTemplate.vue?vue&type=template&id=7decd69d&scoped=true"
import script from "./ResizableImageTemplate.vue?vue&type=script&lang=js"
export * from "./ResizableImageTemplate.vue?vue&type=script&lang=js"

import "./ResizableImageTemplate.vue?vue&type=style&index=0&id=7decd69d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7decd69d"]])

export default __exports__